var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01562 16C5.14062 16 2.51562 14.5 1.07812 12C-0.359375 9.53125 -0.359375 6.5 1.07812 4C2.51562 1.53125 5.14062 0 8.01562 0C10.8594 0 13.4844 1.53125 14.9219 4C16.3594 6.5 16.3594 9.53125 14.9219 12C13.4844 14.5 10.8594 16 8.01562 16ZM8.01562 4C7.57812 4 7.26562 4.34375 7.26562 4.75V8.25C7.26562 8.6875 7.57812 9 8.01562 9C8.42188 9 8.76562 8.6875 8.76562 8.25V4.75C8.76562 4.34375 8.42188 4 8.01562 4ZM7.01562 11C7.01562 11.5625 7.45312 12 8.01562 12C8.54688 12 9.01562 11.5625 9.01562 11C9.01562 10.4688 8.54688 10 8.01562 10C7.45312 10 7.01562 10.4688 7.01562 11Z",
    fill: "#ECB31F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.c022fce44b725bc054775221e61d3c13.svg";
export { ForwardRef as ReactComponent };